module.exports = __webpack_public_path__ + "static/media/Application.4dcb614b.png";